import { render, staticRenderFns } from "./ProductTable.vue?vue&type=template&id=b91b5882&"
import script from "./ProductTable.vue?vue&type=script&lang=js&"
export * from "./ProductTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports